<template>
  <div class="d-flex flex-column">
    <TemplateModal
      :show="modalAction.show"
      @handleClose="modalAction.show = false"
      :center="true"
    >
      <div class="modal-content">
        <div class="modal-header">
          <p class="fw-bold modal-title fsize-14">{{ modalAction.title }}</p>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <label class="col-lg-12 col-form-label fw-bold text-start">
              {{ modalAction.text }}
            </label>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary bg-white text-body fw-bold me-3 border border-0 text-uppercase"
            @click="modalAction.show = false"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-secondary bg-white fw-bold text-danger border border-0 text-uppercase"
            @click="handleConfirm"
          >
            Confirm
          </button>
        </div>
      </div>
    </TemplateModal>
    <div class="voucher-container mb-4">
      <div class="d-flex justify-content-between w-50" style="gap: 12px">
        <div class="d-flex align-items-center" style="gap: 12px">
          <span class="fw-bold">Auto-apply voucher</span>
          <PopOver
            :text="infoAutoApply"
            :popoverStyle="{
              left: '15px',
            }"
          >
            <img alt="info" width="14" height="14" src="@/assets/ic_info.png" />
            <template v-slot:text>
              <span>
                Toggle On akan <b>mengaktifkan</b> Auto Apply Voucher dan Toggle
                Off akan <b>menonaktifkan</b> Auto Apply Voucher pada Buyer App
              </span>
            </template>
          </PopOver>
        </div>
        <Toggle :value="isToggle" @onChange="handleToggle" />
      </div>
    </div>
    <div class="voucher-container mb-8">
      <div class="tab-container">
        <div
          class="tab-item"
          :class="{ active: tab == 'universal' }"
          @click="tab = 'universal'"
        >
          <span> Universal </span>
          <div v-if="tab == 'universal'" class="border-active" />
        </div>
        <div
          class="tab-item"
          :class="{ active: tab == 'nonuniversal' }"
          @click="tab = 'nonuniversal'"
        >
          <span> Non-Universal </span>
          <div v-if="tab == 'nonuniversal'" class="border-active" />
        </div>
      </div>
      <UniversalVouchers v-if="tab == 'universal'" />
      <NonUniversalVouchers v-if="tab == 'nonuniversal'" />
    </div>
  </div>
</template>

<script>
import lodash from "lodash";
import UniversalVouchers from "./UniversalVouchers.vue";
import NonUniversalVouchers from "./NonUniversalVouchers.vue";
import Toggle from "@/components/Toggle.vue";
import PopOver from "@/components/PopOver.vue";
import TemplateModal from "@/components/TemplateModal.vue";

export default {
  components: {
    UniversalVouchers,
    NonUniversalVouchers,
    Toggle,
    PopOver,
    TemplateModal,
  },
  data() {
    return {
      tab: "universal",
      isToggle: false,
      modalAction: {
        isActive: false,
        show: false,
        title: "",
        text: "",
      },
    };
  },
  watch: {
    isAuto(val) {
      this.isToggle = val;
    },
  },
  computed: {
    isAuto() {
      return (
        this.$store.state.globalSettings?.voucher_auto_apply?.is_auto || false
      );
    },
  },
  mounted() {
    this.$store.dispatch("getGlobalSettings");
    this.isToggle = this.isAuto;
  },
  methods: {
    handleToggle(val) {
      if (val) {
        this.modalAction = {
          isActive: val,
          show: true,
          title: "Turn on Auto-apply voucher",
          text: "Are you sure to turn on auto apply voucher? By confirming, this will affect auto apply behaviour in Buyer app.",
        };
      } else {
        this.modalAction = {
          isActive: val,
          show: true,
          title: "Turn off Auto-apply voucher",
          text: "Are you sure to turn off auto apply voucher? By confirming, this will affect auto apply behaviour in Buyer app.",
        };
      }
    },
    handleConfirm() {
      this.isToggle = this.modalAction.isActive;
      this.handleUpdateAutoApply();
      this.modalAction.show = false
    },
    handleUpdateAutoApply: lodash.debounce(function () {
      this.$store.dispatch("voucher/postAutoApply", { is_auto: this.isToggle });
    }, 1000),
  },
};
</script>

<style lang="scss" scoped>
.voucher-container {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 1.5rem;
  border: thin solid #e6eaf5;
}
.tab-container {
  display: flex;
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 1.5rem;
  border-bottom: thin solid #dedede;
}
.tab-item {
  position: relative;
  padding: 0.8rem 1rem;
  padding-top: 0;
  cursor: pointer;
  color: #929293;

  &.active {
    color: #424143;
  }

  .border-active {
    position: absolute;
    background-color: #ffb200;
    height: 4px;
    bottom: -1px;
    left: 0;
    right: 0;
    border-radius: 2px 2px 0 0;
  }
}
</style>
